/* eslint-disable import/order */
import React from 'react';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { componentFilterResource } from '@jira/router-resources__service-desk-customer-service-escalations/src/componentFilterResource.tsx';
import { priorityFilterResource } from '@jira/router-resources__service-desk-customer-service-escalations/src/priorityFilterResource.tsx';
import type { EscalationsAppLayout as ServicedeskCustomerServiceEscalationsType } from '@jira/spa-apps__servicedesk-customer-service-escalations/src/EscalationsAppLayout.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { customerServiceEscalationsRoute } from '@jira/router-routes__servicedesk-customer-service-escalations-routes/src/customerServiceEscalationsRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { APP_NAMES, toPackageName } from '@jira/servicedesk__common/src/toPackageName.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { Route } from '@atlassian/react-resource-router';

const LazyServicedeskCustomerServiceEscalations = lazyForPaint<
	typeof ServicedeskCustomerServiceEscalationsType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-servicedesk-customer-service-escalations", jiraSpaEntry: "async-servicedesk-customer-service-escalations" */ '@jira/spa-apps__servicedesk-customer-service-escalations/src/ServicedeskCustomerServiceEscalations.tsx'
		),
	),
);

const ServicedeskCustomerServiceEscalations = () => (
	<LazyPage
		Page={LazyServicedeskCustomerServiceEscalations}
		pageId="spa-apps/servicedesk/customer-service-escalations"
		shouldShowSpinner
	/>
);

export const customerServiceEscalationsRouteEntry: Route = createEntry(
	customerServiceEscalationsRoute,
	() => ({
		group: 'servicedesk',
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
		},

		resources: [
			...getServiceDeskNavigationResources(),
			...getServicedeskPageContextResources(),
			getConsolidationStateResource(),
			componentFilterResource,
			priorityFilterResource,
		],

		// eslint-disable-next-line no-restricted-syntax
		component: ServicedeskCustomerServiceEscalations,
		perfMetricKey: 'jsm-customer-service-escalations-component-load',
		forPaint: [LazyAtlassianNavigation, LazyServicedeskCustomerServiceEscalations],

		meta: {
			reporting: {
				id: APP_NAMES.CUSTOMER_SERVICE_ESCALATIONS,
				packageName: toPackageName(APP_NAMES.CUSTOMER_SERVICE_ESCALATIONS),
				teamName: 'boysenberry',
			},
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
